import styled from 'styled-components'

interface MainProps {
  mobileDisplay?: string
}

export const MainWidget = styled.div<MainProps>`
    width:14%;
    padding:1rem 1% 1rem 3% ;
    position:fixed;
    height:100vh;
    top:0;
    left:0;
    background: var(--main-bg);
    box-shadow: 18px 4px 35px rgba(0, 0, 0, 0.02);
    overflow-y:auto;

    @media (max-width:728px){
        display: ${p => p.mobileDisplay};
        position:fixed;
        width:80%;
        height:100%;
        z-index:10000;
        padding: 1rem 10% 3rem 10%;
    }
`

export const LogoImageWrap = styled.div`
    margin:0 0 1rem -1rem;
    display:flex;
    align-items:Center;
`
interface LogoProps {
  width?: any
}
export const LogoImage = styled.img<LogoProps>`
    width:${p => p.width || '3rem'};
`

export const NavHeader = styled.h3`
    font-weight: 700;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 1px;
    margin: 2.5rem 0 1rem 0;
    color: #C7C7C7;
    font-family: 'Open Sans', sans-serif;
`

export const NavItem = styled.div`
    display:flex;
    align-items:Center;
    justify-content:space-between;
    margin:0 0 12.82px 0;
    cursor:pointer;
    position:relative;

    > div {
        width: 80%;
        display:flex;
        align-items:Center;
        gap:14.7px;
    }

    p {
        font-size: 14px;
        line-height: 18px;
    }

    :hover {
        opacity:0.6;
    }
`

export const CloseBtn = styled.i`
    display:none;
    position:absolute;
    top:1.5rem;
    right:1.5rem;
    color: #474747;

    @media (max-width:728px){
        display:block;
    }
`

export const NavOption = styled.div`
    position:relative;
    top:0;
    left:10%;
    padding: 0 15px;
    margin:0 0 1rem 0;
    background: #fff;
    font-size: 14px;
    line-height: 30px;
    color: #808080;
`
